module.exports = __webpack_public_path__ + "static/media/SF-3-if-correct.8ad4fa55.mp3";